export const REWARD_TYPE_TRANSLATIONS: { [key: string]: string } = {
	email: "Versende E-Mail",
};

export const RECIPIENT_TYPE_TRANSLATIONS: { [key: string]: string } = {
	admin: "Administrator",
	user: "Benutzer",
};
